{
  "meta": {
    "titel": "Jüdisches Leben in Greifswald",
    "untertitel": "Erinnern und Leben",
    "beschreibung": "Eine digitale Reise durch das jüdische Leben und die jüdische Geschichte in und um Greifswald. Entdecken Sie Stolpersteine, Medienprojekte und historische Orte.",
    "og_image": "img/og-image.webp",
    "keywords": "Jüdisches Leben, Greifswald, Stolpersteine, Holocaust, Erinnerungskultur, Medienprojekte, Judentum, Geschichte",
    "autor": "Medienzentrum Greifswald e.V."
  },
  "navigation": [
    { "label": "Medienprojekte", "anchor": "#medienprojekte", "sectionTitleId": "medienprojekte-title" },
    { "label": "Über uns", "anchor": "#ueber-uns", "sectionTitleId": "ueber-uns-title" },
    { "label": "Begleitmaterial", "anchor": "#begleitmaterial", "sectionTitleId": "begleitmaterial-title" },
    { "label": "Entstehung eines Gedenkortes", "anchor": "#gedenkort", "sectionTitleId": "gedenkort-title" },
    { "label": "Spenden", "anchor": "#spenden", "sectionTitleId": "spenden-title" }
  ],
  "einfuehrungstext": "Was bleibt von Geschichte, wenn sie niemand mehr erzählt?<br>Diese Website widmet sich dem jüdischen Leben und der jüdischen Geschichte in und um Greifswald.\n\nDas Besondere: Nicht nur historische Stimmen kommen zu Wort – auch Schülerinnen und Schüler erzählen in Medienprojekten von ihrer Spurensuche und bringen die Vergangenheit in die Gegenwart.",
  "karte": {
    "titel": "Interaktive Karte des jüdischen Lebens in Greifswald",
    "bild": "img/karte/karte-greifswald.webp",
    "beschreibung": "Die Karte zeigt wichtige Orte jüdischen Lebens in Greifswald. Klicken Sie auf einen Eintrag in der Liste, um mehr zu erfahren."
  },
  "ueber_uns": {
    "titel": "Über uns",
    "text": "Das Projekt „Erinnern und Leben“, unter der Leitung von Magdalena Kunert und angebunden an die offene Jugendarbeit der evangelischen Kirchengemeinden St. Jacobi, St. Marien und Dom St. Nikolai, machte es sich zur Aufgabe, die lange Geschichte jüdischen Lebens in Greifswald neu zu entdecken und seine Spuren im Stadtbild sichtbarer zu machen. An verschiedenen Orten der Stadt lebten, arbeiteten, beteten und wirkten jüdische Menschen – und doch geraten diese Orte und Geschichten oft in Vergessenheit. Die Webseite des Projekts bietet eine digitale Karte der bedeutendsten Orte jüdischen Lebens in Greifswald. Dazu gehören die Stolpersteine, der jüdische Friedhof sowie ein historischer Gebetsraum. Darüber hinaus werden auch der jüdische Friedhof in Niederhof und die jüdische Geschichte Stralsunds thematisiert.\n\nIn Zusammenarbeit mit der Universität Greifswald, dem Medienzentrum Greifswald e.V. und der IGS „Erwin Fischer“ begaben sich Schüler:innen und Projektpartner:innen auf Spurensuche. Gemeinsam erforschten sie das jüdische Leben in Greifswald – damals und heute. Dabei entstanden während spannender Projekt- und Exkursionstage vielfältige Medienprodukte wie Filme, Zeichnungen und Tonaufnahmen, die neue Zugänge zur Geschichte und Gegenwart jüdischen Lebens eröffnen.\n\nFür Lehrkräfte und Bildungseinrichtungen steht außerdem pädagogisches Begleitmaterial zur Verfügung, das den Einsatz der Medien im Unterricht erleichtert und zur vertiefenden Auseinandersetzung mit dem Thema anregt. Die Website versteht sich nicht als abgeschlossenes Produkt. Vielmehr soll sie weiterwachsen – wir freuen uns, auch in Zukunft weitere Medienprojekte zum Thema jüdischer Spuren in Greifswald und Vorpommern hier präsentieren zu können",
    "bilder": [
      {
        "src": "img/ueber-uns/friedhof.webp",
        "titel": "Der zerstörte jüdische Friedhof in Greifswald",
        "beschreibung": "Der jüdische Friedhof ist nicht mehr als solches erkennbar. Durch die Gestaltung von Steinen haben Schülerinnen und Schüler einen ersten Schritt gemacht, um die Geschichte dieses Ortes in Erinnerung zu rufen."
      },
      {
        "src": "img/ueber-uns/stolpersteine.webp",
        "titel": "Stolpersteine - kleine Denkmale",
        "beschreibung": "Wo lebten und wirkten Jüdinnen und Juden – und was geschah mit ihnen? Stolpersteine helfen, die Geschichten hinter den Namen lebendig zu halten."
      },
      {
        "src": "img/ueber-uns/begegnung.webp",
        "titel": "Begegnung mit dem jüdischen Leben",
        "beschreibung": "Nicht nur die jüdische Geschichte, sondern auch das gegenwärtige jüdische Leben ist von Bedeutung: Schülerinnen führen ein Interview mit dem Landesrabbiner Yuriy Kadnykov."
      }
    ],
    "personen": []
  },
  "kontakt": {
    "email": "kontakt@example.de",
    "telefon": "",
    "adresse": "Medienzentrum Greifswald e.V.\nMusterstraße 1\n17489 Greifswald"
  },
  "footer": {
    "impressum_link": "impressum.html",
    "datenschutz_link": "datenschutz.html"
  },
  "foerderer": {
    "titel": "Gefördert durch",
    "logos": [
      {
        "name": "Offene Jugendarbeit",
        "bild": "img/sponsors/01_logo_jugendarbeit.jpg",
        "url": "#"
      },
      {
        "name": "Medienzentrum Greifswald",
        "bild": "img/sponsors/02_MZG_Logo_farbig.png",
        "url": "https://www.medienzentrum-hgw.de"
      },
      {
        "name": "Gesellschaftlicher Zusammenhalt",
        "bild": "img/sponsors/03_gesellschaftlicher_Zusammenhalt.png",
        "url": "#"
      },
      {
        "name": "Vorpommern-Fonds",
        "bild": "img/sponsors/04_Vorp_Fond_Foerderlogo.jpg",
        "url": "#"
      },
      {
        "name": "Johannes-Bugenhagen-Stiftung",
        "bild": "img/sponsors/05_BugenhagenStiftung.png",
        "url": "#"
      }
    ]
  }
}
